import { render, staticRenderFns } from "./v-times.vue?vue&type=template&id=09dab580&scoped=true&"
import script from "./v-times.vue?vue&type=script&lang=js&"
export * from "./v-times.vue?vue&type=script&lang=js&"
import style0 from "./v-times.vue?vue&type=style&index=0&id=09dab580&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dab580",
  null
  
)

export default component.exports